var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlaceholderComponent border border-dashed cursor-pointer m-8 rounded-full mx-auto p-2 w-16 h-16 flex items-center justify-center text-gray-500"},[_c('Icon',{attrs:{"icon":"plus"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }